(function () {
  'use strict';

  const addBusinessDays = (input, amount) => {
    const date = new Date(input);
    let remaining = Math.max(0, Number(amount) || 0);
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }
    return date;
  };

  const addCalendarDays = (input, amount) => {
    const date = new Date(input);
    date.setDate(date.getDate() + Math.max(0, Number(amount) || 0));
    return date;
  };

  const hydrate = (root = document) => {
    root.querySelectorAll('[data-market-delivery-promise][data-known-market="true"]').forEach((element) => {
      if (element.dataset.deliveryHydrated === 'true') return;
      const target = element.querySelector('[data-delivery-date-range]');
      if (!target) return;

      const now = new Date();
      const earliestDispatch = addBusinessDays(now, element.dataset.processingMin);
      const latestDispatch = addBusinessDays(now, element.dataset.processingMax);
      const earliest = addCalendarDays(earliestDispatch, element.dataset.transitMin);
      const latest = addCalendarDays(latestDispatch, element.dataset.transitMax);
      const locale = element.dataset.locale || document.documentElement.lang || 'en';
      const formatter = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' });
      target.textContent = `${formatter.format(earliest)} – ${formatter.format(latest)}`;
      target.setAttribute('title', 'Estimate combines production business days and destination transit days.');
      element.dataset.deliveryHydrated = 'true';
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => hydrate());
  else hydrate();
  document.addEventListener('cart:updated', () => hydrate());
  document.addEventListener('collection:rerendered', () => hydrate());
})();
